module.exports = __webpack_public_path__ + "img/Power-chart@2x.09cd9000.png";